import React, { useMemo } from 'react';
import '../MobileLogin/MobileLogin.css';
import MobileHeader from '../MobileHeader';
import DesktopThreadsBackground from '../../desktop/DesktopLogin/DesktopThreadsBackground';
import loopinoLogo from '../../../assets/images/LOOPINO-logo-new.svg';
import useLanguage from '../../../hooks/useLanguage';
import useVerifyEmailFlow from '../../../hooks/useVerifyEmailFlow';

const MobileVerifyEmail = () => {
  const { t } = useLanguage();
  const heroThreadsColor = useMemo(() => [0.98, 0.92, 1], []);
  const { status, countdown, redirectToLogin } = useVerifyEmailFlow({ redirectDelayMs: 5000 });

  const isSuccess = status === 'success';
  const isVerifying = status === 'verifying' || status === 'idle';
  const messageToneClass = isSuccess || isVerifying ? 'success' : '';

  const statusMessage = (() => {
    if (status === 'success') {
      return t('login.verifyEmail.status.success');
    }
    if (status === 'error') {
      return t('login.verifyEmail.status.error');
    }
    if (status === 'missing') {
      return t('login.verifyEmail.status.missing');
    }
    return t('login.verifyEmail.status.verifying');
  })();

  return (
    <div className="mobile-login-container">
      <MobileHeader currentScreen="login" />

      <div className="mobile-login-content">
        <section className="mobile-login-hero" aria-live="polite">
          <div className="mobile-hero-glow" aria-hidden="true" />
          <div className="mobile-login-hero-card">
            <DesktopThreadsBackground
              color={heroThreadsColor}
              amplitude={1}
              distance={0.3}
              enableMouseInteraction={false}
              aria-hidden="true"
            />
            <div className="mobile-hero-content">
              <div className="mobile-hero-branding">
                <img src={loopinoLogo} alt="Loopino" />
              </div>
              <h2>Il tuo social media manager AI powered</h2>
              <p>
                Dall’idea alla pubblicazione, in un unico flusso: l’AI suggerisce format, rifinisce i copy, propone
                varianti creative e tiene aggiornato il calendario editoriale. Tu ci metti la visione, Loopino ti
                aiuta a restare costante.
              </p>
              <div className="mobile-hero-chips">
                <span>Bacheca idee e trend</span>
                <span>Calendario editoriale</span>
                <span>Copy &amp; visual con l&apos;AI</span>
              </div>
              <div className="mobile-hero-stats">
                <div>
                  <strong>1 flusso</strong>
                  <span>Idea → asset → calendario → pubblica</span>
                </div>
                <div>
                  <strong>Creatività illimitata</strong>
                  <span>nessuna sindrome del foglio bianco</span>
                </div>
              </div>
            </div>
          </div>
        </section>

        <div className="mobile-login-card">
          <div className="mobile-card-header">
            <h1 className="mobile-card-title">{t('login.verifyEmail.title')}</h1>
            <p className="mobile-card-description">{t('login.verifyEmail.description')}</p>
          </div>

          <div className="mobile-login-form">
            <div className={`mobile-error-message mobile-general-error ${messageToneClass}`}>
              <div className="mobile-general-message-content">
                <span>{statusMessage}</span>
                {countdown !== null && (
                  <span className="mobile-general-subtext">
                    {t('login.verifyEmail.redirecting', { count: countdown })}
                  </span>
                )}
              </div>
              {isVerifying && <div className="mobile-loading-spinner" aria-hidden="true" />}
            </div>

            <div className="mobile-submit-section">
              <button type="button" className="mobile-submit-button" onClick={redirectToLogin}>
                {t('login.verifyEmail.cta')}
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default MobileVerifyEmail;
